import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "passProps"];
import { Children } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Sale... Remove this comment to see the full error message
import cloneElement from 'SalesContentIndexUI/utils/cloneElement';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultSlot = props => {
  const {
      children,
      passProps = true
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (children) {
    const childrenWithProps = Children.map(children, child => {
      return passProps ? cloneElement(child, otherProps) : child;
    });
    return /*#__PURE__*/_jsx("div", {
      children: childrenWithProps
    });
  }
  return /*#__PURE__*/_jsx("div", {});
};
export default DefaultSlot;